import { EnShift } from '../../enum/en-shift.enum';
import { IActivity } from './iactivity';

export interface IShift {
    shiftName: EnShift | string;
    activities: IActivity[];
}
